import script from "./HTPunchBoardSetting.vue?vue&type=script&setup=true&lang=js"
export * from "./HTPunchBoardSetting.vue?vue&type=script&setup=true&lang=js"

import "./HTPunchBoardSetting.vue?vue&type=style&index=0&id=446789ae&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-446789ae"]])

export default __exports__